"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateTime = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactDatepicker = _interopRequireDefault(require("react-datepicker"));
var _reactstrap = require("reactstrap");
require("react-datepicker/dist/react-datepicker.css");
require("./style.css");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const DateTime = props => {
  const {
    name,
    errors,
    isRequired,
    label,
    onChange
  } = props;
  return /*#__PURE__*/_react.default.createElement(_reactstrap.FormGroup, {
    className: `form-group ${errors && errors[name] ? 'is-invalid' : 'is-valid'}`
  }, label && /*#__PURE__*/_react.default.createElement(_reactstrap.Label, {
    className: "form__label"
  }, label, isRequired && /*#__PURE__*/_react.default.createElement("span", {
    className: "asterisk"
  }, "*")), /*#__PURE__*/_react.default.createElement(_reactDatepicker.default, (0, _extends2.default)({}, props, {
    onChange: onChange,
    selected: props.value ? new Date(props.value) : null
  })), /*#__PURE__*/_react.default.createElement("p", {
    className: "form--control__error"
  }, errors && errors[name]?.message));
};
exports.DateTime = DateTime;
const defaultProps = {
  selected: null,
  className: 'form-control',
  dateFormat: 'MM/dd/yyyy',
  disabled: false,
  name: 'dateTime',
  showTimeSelect: false,
  isClearable: false,
  label: '',
  startDateLabel: '',
  endDateLabel: '',
  placeholderText: '',
  placeholderTextEndDate: '',
  placeholderTextStartDate: ''
};
const propTypes = {
  className: _propTypes.default.string,
  dateFormat: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  endDate: _propTypes.default.instanceOf(Date),
  endDateLabel: _propTypes.default.string,
  includeTimes: _propTypes.default.array,
  injectTimes: _propTypes.default.array,
  isClearable: _propTypes.default.bool,
  label: _propTypes.default.string,
  maxDate: _propTypes.default.instanceOf(Date),
  maxTime: _propTypes.default.instanceOf(Date),
  minDate: _propTypes.default.instanceOf(Date),
  minTime: _propTypes.default.instanceOf(Date),
  name: _propTypes.default.string,
  onChange: _propTypes.default.func,
  placeholderText: _propTypes.default.string,
  placeholderTextEndDate: _propTypes.default.string,
  placeholderTextStartDate: _propTypes.default.string,
  readOnly: _propTypes.default.bool,
  required: _propTypes.default.bool,
  selected: _propTypes.default.instanceOf(Date),
  showTimeSelect: _propTypes.default.bool,
  startDate: _propTypes.default.instanceOf(Date),
  startDateLabel: _propTypes.default.string,
  timeFormat: _propTypes.default.string,
  timeIntervals: _propTypes.default.string,
  timeInputLabel: _propTypes.default.string,
  timeCaption: _propTypes.default.string
};
DateTime.defaultProps = {
  ...defaultProps
};
DateTime.propTypes = {
  ...propTypes
};